import { makeStyles, tokens } from "@fluentui/react-components";
import { $sky60 } from "../cssjs/colors";

export const labelStyles = makeStyles({
  overViewLabel: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightMedium,
    color: $sky60,
  },
});
